import { render } from "./_ModalFooter.vue?vue&type=template&id=2c062871&scoped=true"
import script from "./_ModalFooter.vue?vue&type=script&lang=js"
export * from "./_ModalFooter.vue?vue&type=script&lang=js"

import "./_ModalFooter.vue?vue&type=style&index=0&id=2c062871&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c062871"],['__file',"src/scripts/sections/modals/_ModalFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c062871"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c062871', __exports__)) {
    api.reload('2c062871', __exports__)
  }
  
  module.hot.accept("./_ModalFooter.vue?vue&type=template&id=2c062871&scoped=true", () => {
    api.rerender('2c062871', render)
  })

}


export default __exports__